<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2 langkey="phFilterTagDialog_Title"></h2>
    <div class="filter-dialog-description">
      <span langkey="phFilterTagDialog_Description"></span>
    </div>
    <div class="ya-dialog-content">
      <div class="item-tag-wrapper" (scroll)="onTagListScroll($event)">
        <div class="item-tag-container">
          <ng-container *ngFor="let itemTag of dialogData.itemTags">
            <div class="tag-wrapper">
              <ng-container *ngIf="dialogData.itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
              </ng-container>
              <ng-template #iconTagTemplate>
                <div class="tag-icon-container">
                  <div class="inline-icon" [innerHTML]="svgSanitizer(itemTag.svgIcon)"></div>
                  <div class="tag-label">{{itemTag.label}}</div>
                </div>
              </ng-template>
              <ng-template #textTagTemplate>
                <div class="tag-label-container">
                  <span class="tag-label">{{itemTag.label}}</span>
                </div>
              </ng-template>
              <div class="tag-selection-wrapper">
                <a matRipple matRippleCentered="true"
                  [ngClass]="itemTag.itemTagStatus === itemTagStatus.like ? 'item-status-active' : ''"
                  (click)="setItemTagStatus(itemTag, itemTagStatus.like)">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-thumb-up"></div>
                </a>
                <a matRipple matRippleCentered="true"
                  [ngClass]="itemTag.itemTagStatus === itemTagStatus.dislike ? 'item-status-active' : ''"
                  (click)="setItemTagStatus(itemTag, itemTagStatus.dislike)">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-thumb-down"></div>
                </a>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="showGradient">
        <div class="content-gradient"></div>
      </ng-container>
    </div>
    <div class="saveconfirm-checkbox-wrapper">
      <div class="saveconfirm-checkbox-check">
        <mat-checkbox (change)="saveItemTags($event)" [(ngModel)]="saveToUserData" class="custom-ripple" name="save">
        </mat-checkbox>
      </div>
      <div class="saveconfirm-checkbox-content ya-caption" #privacyContent langkey="phFilterTagDialog_Checkbox_Content">
      </div>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="setTagFilter()"><span
                langkey="phFilterTagDialog_Button_Save"></span></button>
          </div>
          <div class="ya-button-container">
            <button mat-stroked-button (click)="resetTagFilter()"><span
                langkey="phFilterTagDialog_Button_Close"></span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>